'use strict';

var _ = require('underscore');
var Radio = require('backbone.radio');
var polyglot = require('../utilities/polyglot').default;
var Marionette = require('backbone.marionette');
var Tracker = require('../../analytics/events').default;

export default Marionette.View.extend({
  className: 'coconut-modal',
  template: require('./templates/cancel-request-toast.hbs'),
  ui: {
    notes: '.notes',
    cancelMsg: '.cancel-message',
    close: '.close-button',
    confirm: '.confirm-cancel',
  },
  events: {
    'click @ui.close': 'dismiss',
    'click @ui.confirm': 'onConfirmClicked',
  },

  initialize: function (options) {
    this.parent = options.parent;
    this.model = options.model;
    this.buttonClass = 'green';
    this.className = 'coconut-modal';
  },

  serializeData: function() {
    return {
      cancelTitle: polyglot.t('pages.waitlist_confirmation.get_removed'),
      message: polyglot.t('pages.waitlist_confirmation.are_you_sure'),
      backMessage: polyglot.t('cancel'),
      buttonMessage: polyglot.t('pages.waitlist_confirmation.remove_me'),
      buttonClass: this.buttonClass,
    };
  },

  /**
   * Display the modal.
   */
  show: function() {
    this.$el.removeClass('hide');
    this.$el.addClass('show');
  },

  hideErrors() {
    this.$('.form-error').remove();
  },

  /**
   * Dismiss the modal.
   */
  dismiss: function (evt) {
    evt.preventDefault();
    this.$el.removeClass('show');
    this.$el.addClass('hide');
  },

  onConfirmClicked: function () {
    Tracker.trackEvent('Removed self from waitlist', 'click');
    Radio.channel('confirm-request-cancel').trigger('confirm:cancel', this);
  },
});
